import BREAKPOINTS from '@loggi/ui/components/utils/breakpoints';

export const GUTTERS = ['top', 'right', 'bottom', 'left'];
export const GUTTER_SIZES = [
  'none',
  'quarter',
  'half',
  'normal',
  'onehalf',
  'double',
  'triple'
];

export const gutterShape = {
  top: null,
  right: null,
  bottom: null,
  left: null
};

export const breakpointGutterShape = {
  xs: gutterShape,
  sm: gutterShape,
  md: gutterShape,
  lg: gutterShape,
  xl: gutterShape,
  xxl: gutterShape
};

/**
 * Organizes a gutter object
 * @param {string} general - a gutter size value.
 * @param {object} shape - a complete or a fragment of a gutter object
 * @return {object} the gutter object
 */
export const groupGutters = (general = null, shape = null) => {
  const newShape = Object.assign({}, gutterShape, shape);
  return {
    top: general || newShape.top,
    right: general || newShape.right,
    bottom: general || newShape.bottom,
    left: general || newShape.left
  };
};

/**
 * Organize the breakpoint object and completes not inserted values with gutter shape
 * @param {object} breakpoints - a breakpoint object.
 * @return {object} a complete breakpoint gutter object
 */
export const groupGuttersByBreakpoint = breakpoints => {
  return {
    xs: breakpoints.xs || gutterShape,
    sm: breakpoints.sm || gutterShape,
    md: breakpoints.md || gutterShape,
    lg: breakpoints.lg || gutterShape,
    xl: breakpoints.xl || gutterShape,
    xxl: breakpoints.xxl || gutterShape
  };
};

/**
 * Organizes the gutter prop to an object that contains breakpoints and gutter values
 * @param {string|object} prop - gutter component prop.
 * @param {object} oldProps - old deprecated pattern already supported by Col component.
 * @return {object} a complete breakpoint gutter object
 */
export const gutterPropMeasure = (prop, oldProps = null) => {
  if (prop) {
    if (typeof prop === 'string') {
      const groupGutter = groupGutters(prop);
      return groupGuttersByBreakpoint({ xs: groupGutter });
    } else if (typeof prop === 'object') {
      const propKeys = Object.keys(prop);
      const gutterIntersection = propKeys.filter(
        n => GUTTERS.indexOf(n) !== -1
      );
      const breakpointIntersection = propKeys.filter(
        n => BREAKPOINTS.indexOf(n) !== -1
      );
      if (gutterIntersection.length) {
        const gutterFragment = groupGutters(null, prop);
        return groupGuttersByBreakpoint({ xs: gutterFragment });
      } else if (breakpointIntersection.length) {
        // TODO: validate the value inside of breakpoint object received
        return groupGuttersByBreakpoint(prop);
      }
    }
    return prop;
  }
  return oldProps ? oldProps : breakpointGutterShape;
};
